import React from 'react'

import { ModalPaymentInfoContainer } from './ModalPaymentPix'

export  function ModalPaymentInstructions({handleOpenModalPayment}) {
    return (
        <>
            <ModalPaymentInfoContainer>
                {/* <div class="container">
                    <div class="interior">
                        <a href="#open-modal"> Instruções de como usar pix para pagar:</a>
                    </div>
                </div> */}
                <div id="open-modal" class="modal-window">
                    <div>
                        {/* <a href="#" title="Close" onClick={handleOpenModalPayment} class="modal-close">Fechar</a> */}
                        <h3>Como fazer sua recarga com PIX:</h3>
                        <div class="list">
                            <div>Acesse o Internet Banking ou 
                              <span style={{ marginRight:'35px'}}>  aplicativo do seu banco</span>
                            </div>
                            <div>Acesse a opção Pix</div>
                            <div>Selecione a opção Pix Copia e Cola</div>
                            <div>Cole o código no campo indicado 
                            confirme o pagamento
                            </div>
                            <div>
                                Pronto! Sua recarga será feita em até 
                                5 minutos. Aproveite seus benefícios.
                            </div>
                        </div>
                        <div className="footer-modal">
                            <button 
                            onClick={handleOpenModalPayment}
                            class="btn btn-payment">
                            
                                OK
                            </button>
                        </div>

                    </div>
                    
                    
                </div>

                    
            </ModalPaymentInfoContainer>
        </>
    )
}
